import { BRAND } from "@/lib/brand";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    kicker: "How we care for your information.",
    body: [
      "THE KC INDIA (Kedarnath Cottage) respects the privacy of every guest. We collect only the information you share through our enquiry forms or direct communication — such as your name, contact number and travel preferences — and use it solely to serve your journey.",
      "We never sell, rent or share your personal information with any third party for marketing purposes. Communication is limited to your specific enquiry and related travel assistance.",
      `If you wish to review, update or delete your information, please write to ${BRAND.email}.`,
    ],
  },
  terms: {
    title: "Terms & Conditions",
    kicker: "The understanding between us.",
    body: [
      "By enquiring or booking with THE KC INDIA, you agree to our standard hospitality terms. All rates, availability and package details are indicative and confirmed only in writing by our team.",
      "Weather, road and helicopter schedules in the Himalayan region can change without notice. THE KC INDIA acts in good faith to advise guests and cannot be held liable for delays or cancellations caused by natural events.",
      "For clarifications, please contact our team at " + BRAND.phone + ".",
    ],
  },
  cancellation: {
    title: "Cancellation Policy",
    kicker: "Fair, flexible, and honest.",
    body: [
      "Cancellations are accepted with reasonable notice. Refund timelines and any applicable fees will be shared with the booking confirmation.",
      "In case of unavoidable weather-related disruptions or helicopter cancellations, our team will work with you to reschedule your journey wherever possible.",
      "Written cancellations should be sent to " + BRAND.email + " and " + BRAND.supportEmail + ".",
    ],
  },
};

export default function Policy({ kind = "privacy" }) {
  const c = CONTENT[kind];
  return (
    <div className="max-w-3xl mx-auto px-6 md:px-12 py-24 md:py-32" data-testid={`page-${kind}`}>
      <div className="overline">Policy</div>
      <h1 className="h-display text-5xl md:text-7xl mt-6 font-light tracking-[-0.03em]">{c.title}</h1>
      <p className="font-serif-italic text-2xl md:text-3xl text-ink-soft mt-6">{c.kicker}</p>
      <div className="hairline-gold w-1/4 my-12" />
      <div className="space-y-8 text-ink-soft leading-[1.85] text-[15px]">
        {c.body.map((p, i) => <p key={i}>{p}</p>)}
      </div>
      <p className="mt-16 text-[10px] uppercase tracking-[0.32em] text-ink-mute">Last updated · {new Date().toLocaleDateString("en-IN", { month: "long", year: "numeric" })}</p>
    </div>
  );
}
